module.exports = __webpack_public_path__ + "assets/img/ie_memory.dd280820.jpg";